import immutabilityHelper from 'immutability-helper'

import buildUpdate from './buildUpdate'

const update = (list, path, newObject) => {
  return immutabilityHelper(list, buildUpdate(path, newObject))
}

export default update
